import { render } from "./ProductItemTableCard.vue?vue&type=template&id=ead38c12&scoped=true"
import script from "./ProductItemTableCard.vue?vue&type=script&lang=js"
export * from "./ProductItemTableCard.vue?vue&type=script&lang=js"

import "./ProductItemTableCard.vue?vue&type=style&index=0&id=ead38c12&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ead38c12"]])

export default __exports__